import React from 'react';

export const Header = ({ title }) => {
  return (
    <header className="Header">
      <h1>{ title }</h1>
    </header>
  );
}



// WEBPACK FOOTER //
// ./src/components/Header.js